export const styles = {
  backdrop: {
    width: '150px',
    height: '150px',
    position: 'relative',
  },

  doughnut: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },

  percentageLabelWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
  },

  percentageLabel: {
    textAlign: 'center',
    fontSize: 30,
    lineHeight: '38px',
  },
};
